import React, { useEffect, useState } from "react";
import { numberToFinanceFormat } from "../../../utils";
import Button from "react-bootstrap/Button";
import {t} from "i18next";

const PhotoViewer = ({ currentPhoto, onClose }) => {

    const downloadPhoto = () => {
        fetch(currentPhoto.url)
            .then(response => response.blob())
            .then(blob => {
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = currentPhoto.name || 'file.jpg';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })
            .catch(e => {
                console.error("Ошибка при скачивании файла:", e);
            });
    };

    return (
        <>
            <div className="modal-overlay">
                <div style={{
                    backgroundColor: "#ffffff",
                    height: "600px",
                    width: "750px",
                    margin: "20px auto",
                    borderRadius: "6px",
                }}>
                    <div style={{
                        padding: "14px 24px",
                        display: "flex",
                        alignItems: "center",
                        backgroundColor: "#ffffff",
                        justifyContent: "space-between",
                        borderBottom: "1px solid #eeeeee",
                        borderTopLeftRadius: "6px",
                        borderTopRightRadius: "6px",
                    }}>
                        <div style={{ fontSize: "16px", backgroundColor: "#ffffff" }}>
                            <img src={currentPhoto.url} style={{ objectFit: 'cover' }} width="700px" height="500px" alt="" />
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Button style={{ width: '200px', marginRight: '20px' }} variant="outline-primary" onClick={() => {
                            downloadPhoto()
                        }}>{t('download')}
                        </Button>
                        <Button style={{ width: '200px' }} variant="outline-primary" onClick={() => {
                            onClose()
                        }}>{t('confirmDocs.buttonClose')}
                        </Button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PhotoViewer;
